export default __webpack_public_path__ + "static/media/rapidpays.15ca807b.svg";